import { useOnClickOutside } from "@flatfile/design-system";
import { useState, useCallback, useEffect } from "react";
const useDropdown = ({
  dropdownRef,
  onSelectionChange,
  onOpenCallback
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [popoverIsOpen, setPopoverIsOpen] = useState(false);
  const onOpen = useCallback(async () => {
    onOpenCallback && await onOpenCallback();
    setIsOpen(true);
  }, [setIsOpen, onOpenCallback]);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);
  const focusInput = () => {
    var _a;
    const inputs = (_a = dropdownRef == null ? void 0 : dropdownRef.current) == null ? void 0 : _a.getElementsByTagName("input");
    if (inputs == null ? void 0 : inputs.length) {
      inputs[0].focus();
    }
  };
  const onOpenChange = (open) => {
    if (!open) {
      focusInput();
    }
    setPopoverIsOpen(open);
  };
  const onSelectedChange = (value) => {
    if (onSelectionChange) {
      onSelectionChange(value);
    }
    onClose();
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onClose();
    }
  };
  useOnClickOutside(dropdownRef ?? { current: null }, onClose);
  useEffect(() => {
    if (isOpen) {
      focusInput();
    }
  }, [isOpen]);
  return {
    onOpenChange,
    onSelectedChange,
    onKeyDown,
    isOpen,
    onOpen,
    onClose,
    dropdownOpen: popoverIsOpen
  };
};
export {
  useDropdown
};
